import classnames from "classnames";
import React from "react";
import introFamilyDesktop from "../../../assets/images/pages/landing/intro-family-desktop.png";
import introFamily from "../../../assets/images/pages/landing/intro-family.png";
import pacificoLogo from "../../../assets/images/pages/landing/pacifico-logo.png";
import bcpLogo from "../../../assets/images/pages/shared/bcp-logo.png";
import vidaLeyLogo from "../../../assets/images/pages/landing/vida-ley-logo.png";
import { Expanded } from "../../../components/layout/flex";
import { Column, Row } from "../../../components/layout/flex-layout";
import { SizedBox } from "../../../components/layout/sized-box";
import { SpacingBox } from "../../../components/layout/spacing-box";
import { Typography } from "../../../components/typography/typography";
import { WaveInverse } from "../../../components/waves/WaveInverse";
import { useWindowResize } from "../../../hooks/use-windows-resize";
import { LandingKnowMoreArrow } from "./know-more-arrow";
import { useChannel } from "../../../libs/channels/hooks/use-channel";

const LandingIntroMobile = () => (
    <>
        <Row justify="center">
            <img
                height={52}
                width={113}
                src={vidaLeyLogo}
                alt="vida ley logo"
            />
        </Row>
        <Column className="landing-intro__content" justify="center">
            <SpacingBox pl={18}>
                <Typography fontSize={20} variant="white">
                    <b>
                        Protege a tus<br></br>trabajadores<br></br>desde el
                        <br></br>
                        primer día
                    </b>
                </Typography>
            </SpacingBox>
            <img src={introFamily} alt="familia" />
        </Column>
        <LandingKnowMoreArrow />
        <WaveInverse />
    </>
);

const LandingIntroDesktop = () => {
    return (
        <>
            <Row style={{ marginBottom: "-6%" }}>
                <Expanded>
                    <SpacingBox pt={55}>
                        <Row justify="center">
                            <img
                                width={177}
                                height={81}
                                src={vidaLeyLogo}
                                alt="vida ley logo"
                            />
                        </Row>
                    </SpacingBox>
                </Expanded>
                <SpacingBox pt={55}>
                    <SizedBox width={336} style={{ textAlign: "center" }}>
                        <Typography fontSize={36} variant="white">
                            <b>
                                Protege a tus<br></br>trabajadores desde
                                <br></br>el primer día
                            </b>
                        </Typography>
                    </SizedBox>
                </SpacingBox>
                <Expanded>
                    <Row justify="flex-end">
                        <img
                            className="landing-intro__familiy"
                            src={introFamilyDesktop}
                            alt="familia"
                        />
                    </Row>
                </Expanded>
            </Row>
            <LandingKnowMoreArrow />
            <WaveInverse />
        </>
    );
};

export const LandingIntro = () => {
    const { isMobile } = useWindowResize();
    const { isBcpTheme } = useChannel();
    return (
        <div
            data-testid="LandingIntro"
            className={classnames("landing-intro", {
                "landing-intro--desktop": !isMobile,
                "landing-intro--mobile": isMobile,
                "landing-intro--bcp": isBcpTheme,
            })}
        >
            <SpacingBox pt={14} />
            <Row className="landing-intro__header" justify="space-around">
                <img
                    width={isMobile ? 107 : 140}
                    height={isMobile ? 25 : 33}
                    src={pacificoLogo}
                    alt="pacifico logo"
                    className="landing-intro__header--pacifico-logo"
                />
                {isBcpTheme && (
                    <img
                        width={isMobile ? 107 : 140}
                        height={isMobile ? 25 : 33}
                        src={bcpLogo}
                        alt="bcp logo"
                        className="landing-intro__header--bcp-logo"
                    />
                )}
            </Row>
            <SpacingBox pt={18} />
            {isMobile ? <LandingIntroMobile /> : <LandingIntroDesktop />}
        </div>
    );
};
